import { useEffect, useState } from "react";
import API_URL from "../config";

export default function GrilleImages() {
  const [tuiles, setTuiles] = useState([]);

  useEffect(() => {
    fetch(`${API_URL}/api/tuiles`)
      .then(res => res.json())
      .then(data => setTuiles(data))
      .catch(err => console.error(err));
  }, []);

  if (tuiles.length === 0) return null;

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 auto-rows-[280px]">
        {tuiles.map((tuile) => (
          <div
            key={tuile._id}
            className={`relative rounded-2xl overflow-hidden group cursor-pointer ${
              tuile.taille === "grande" ? "col-span-2" : "col-span-1"
            }`}
            onClick={() => tuile.lien && window.open(tuile.lien, "_blank")}
          >
            <img
              src={tuile.imageUrl}
              alt={tuile.titre}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            {tuile.titre && (
              <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <h3 className="text-white text-xl font-semibold">{tuile.titre}</h3>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}